import { BareActionContext } from 'vuex-typex'
import { StatementState } from '../state'
import { RootState } from '@/store'
import statementStore from '../statement-store'
import setMeta from './set-meta'
import { IStatement, StatementMeta, Statement } from '@/model/statement'

export default async function processStatements (context: BareActionContext<StatementState, RootState>, statements: IStatement[]) {
    for(let i=0; i<statements.length; i++) {
        const statement = statementStore.state.statementMap.get(statements[i].id as number)
        if (statement) {
            statements[i] = statement
        } else {
            statementStore.state.statementMap.set(statements[i].id as number, statements[i])
            statements[i].meta = new StatementMeta()
        }
    }
    statementStore.commitSetStatements({ statements: statements })
    statementStore.commitSetIsLoading({isLoading: false})
    for(let i=0; i<statements.length; i++) {
        if (!statements[i].isMetaSet) {
            setMeta(context, statementStore.state.statements[i])
        }
    }

    return
}
